//chain config for chiado
import type { CirclesConfig } from '@circles-sdk/sdk';

export const config: CirclesConfig = {
  circlesRpcUrl: 'https://rpc.aboutcircles.com/',
  pathfinderUrl: 'https://pathfinder.aboutcircles.com',
  v1HubAddress: '0x29b9a7fbb8995b2423a71cc17cf9810798f6c543',
  v2HubAddress: '0xc12C1E50ABB450d6205Ea2C3Fa861b3B834d13e8',
  nameRegistryAddress: '0xA27566fD89162cC3D40Cb59c87AAaA49B85F3474',
  migrationAddress: '0xD44B8dcFBaDfC78EA64c55B705BFc68199B56376',
  profileServiceUrl: 'https://rpc.aboutcircles.com/profiles/',
  baseGroupMintPolicy: '0xcCa27c26CF7BAC2a9928f42201d48220F0e3a549',
};

export const configChiado: CirclesConfig = {
  circlesRpcUrl: 'https://chiado-rpc.aboutcircles.com',
  pathfinderUrl: 'https://chiado-pathfinder.aboutcircles.com',
  profileServiceUrl: 'https://chiado-pathfinder.aboutcircles.com/profiles/',
  v1HubAddress: '0xdbf22d4e8962db3b2f1d9ff55be728a887e47710',
  v2HubAddress: '0xb80feeDfEce647dDc709777D5094fACD157BA001',
  migrationAddress: '0x12E815963A0b910288C7256CAD0d345c8F5db08E',
  nameRegistryAddress: '0x24b3fDCdD9fef844fB3094ef43c0A6Ac23a6dF9E',
  baseGroupMintPolicy: '0xE35c66531aF28660a1CdfA3dd0b1C1C0245D2F67',
};

export const bootstrapPeriods: { [contract: string]: number } = {
  '0xc12c1e50abb450d6205ea2c3fa861b3b834d13e8':
    /*deployedAt:*/ 1728824950 + /*bootsrapTime:*/ 2883058,
  '0x3d61f0a272ec69d65f5cff097212079aafde8267':
    /*deployedAt:*/ 1730401610 + /*bootsrapTime:*/ 1313598,
};
